import { render, staticRenderFns } from "./dialog-top.vue?vue&type=template&id=0fc1e712&"
import script from "./dialog-top.vue?vue&type=script&lang=js&"
export * from "./dialog-top.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports